function createFormDataFromObject(obj, form = null, namespace = '') {
	let formData = form || new FormData()

	for (let property in obj) {
		if (obj.hasOwnProperty(property)) {
			let formKey = namespace ? `${namespace}[${property}]` : property

			if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
				createFormDataFromObject(obj[property], formData, formKey)
			} else {
				let value = obj[property]

				if (typeof value === 'boolean') {
					value = value ? 1 : 0
				}

				formData.append(formKey, value)
			}
		}
	}

	return formData
}

function handlePayload(payload) {
	let hasFiles = false

	for (const key in payload) {
		const value = payload[key]

		if (value instanceof File) {
			hasFiles = true
			break
		} else if (Array.isArray(value)) {
			for (const item of value) {
				if (item instanceof File) {
					hasFiles = true
					break
				}
			}
		}
	}

	if (hasFiles) {
		const formData = createFormDataFromObject(payload)

		return {
			payload: formData,
			hasFiles
		}
	} else {
		return { payload, hasFiles }
	}
}

export default handlePayload
